import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import first from 'lodash/first';
import NewAdsBanner from '../../NewAdsBanner';
import WithThirdPartyAds from '../../WithThirdPartyAds';
import { FeaturedAd } from '../../../../FeaturedAd';
import { ListAds } from '..';
import { formatCustomTargetingObject, adSenseAttributionChannel } from '../../../../utils/adSense';
import { VERTICAL_NAMES } from '../../../../common/constants/common';
import { shouldShowAFSCommingFromAlert } from '../../../utils';

class List extends React.PureComponent {
  render() {
    const {
      searchParameters,
      isFetching,
      trovit,
      config,
      lastFreshAd,
      thirdPartyAdsConfig,
      similarContentAdsCount,
      personalizedAds,
    } = this.props;

    const verticalName = config.verticalName;

    // Add similar content ads count to the organic ads count
    // to increase the chance to show Google AFS Native
    let { adsCount } = this.props;
    const isHomesOrCarsVertical =
      verticalName === VERTICAL_NAMES.homes || verticalName === VERTICAL_NAMES.cars;
    if (isHomesOrCarsVertical) {
      adsCount += similarContentAdsCount;
    }

    const adsPlainList = (
      <ListAds
        searchParameters={searchParameters}
        verticalName={verticalName}
        isFetching={isFetching}
        trovit={trovit}
        lastFreshAd={lastFreshAd}
      />
    );

    const abTest = get(trovit, ['abTest', 'id']) ? get(trovit, ['abTest', 'option']) : '';

    if (thirdPartyAdsConfig) {
      const isSemUrl = get(searchParameters, 'isSemUrl');
      const isRetentionUrl = !!get(searchParameters, 'boost_ads_since');

      const countryCode = config.countryCode;
      const locale = config.locale;

      const what = get(searchParameters, 'what_d');
      const where = get(searchParameters, 'where', '');
      const query = where ? `${what} ${where}` : what;

      const page = get(searchParameters, 'page');
      const attributionChannel = adSenseAttributionChannel({
        countryCode,
        verticalName,
        isRetention: isRetentionUrl,
        isSem: isSemUrl,
        origin: get(trovit, ['query', 'origin']) || trovit.origin,
        abTest,
      });

      const types = get(config, ['vertical', 'types']);
      const typeId = get(searchParameters, 'type_id');
      const typeIdDefault = parseInt(first(Object.keys(types)), 10);
      const queryContextKeys = get(config, ['vertical', 'afsQueryContextTranslationKeys']);
      const queryContextTranslationKey = get(queryContextKeys, `${typeId}`)
        ? queryContextKeys[`${typeId}`]
        : queryContextKeys[`${typeIdDefault}`];

      const thirdPartyAdsConfigExtended = {
        ...thirdPartyAdsConfig,
        queryContextTranslationKey,
        countryCode,
        page,
        query,
        channel: attributionChannel,
        verticalName,
        locale,
      };

      const dfpCustomTargeting = formatCustomTargetingObject({ trovit, config, searchParameters });
      const shouldShowDFP = get(config, ['vertical', 'shouldShowDFP']);

      const shouldShowAFS = shouldShowAFSCommingFromAlert(
        isRetentionUrl,
        trovit.origin,
        countryCode,
        verticalName
      );

      return (
        <div>
          {lastFreshAd > 0 && <NewAdsBanner what={get(searchParameters, 'whatAccented')} />}

          {/* Test AB for task PWA-1095 - More like this (Featured ad on top) */}
          {isRetentionUrl && <FeaturedAd />}

          <WithThirdPartyAds
            config={thirdPartyAdsConfigExtended}
            isSemUrl={isSemUrl}
            isRetentionUrl={isRetentionUrl}
            dfpCustomTargeting={dfpCustomTargeting}
            adsCount={adsCount}
            similarContentAdsCount={similarContentAdsCount}
            dfpNetworkId={get(config, ['client', 'dfpNetworkId'])}
            isFetching={isFetching}
            shouldShowDFP={shouldShowDFP}
            shouldShowAFS={shouldShowAFS}
            pageviewId={trovit.pageviewId}
            appEnvironment={get(config, ['env', 'appEnvironment'])}
            personalizedAds={personalizedAds}
          >
            {adsPlainList}
          </WithThirdPartyAds>
        </div>
      );
    }

    return (
      <div>
        {lastFreshAd > 0 && <NewAdsBanner what={get(searchParameters, 'whatAccented')} />}
        {adsPlainList}
      </div>
    );
  }
}

List.defaultProps = {
  thirdPartyAdsConfig: null,
  lastFreshAd: 0,
};

List.propTypes = {
  searchParameters: PropTypes.object.isRequired,
  lastFreshAd: PropTypes.number,
  adsCount: PropTypes.number.isRequired,
  similarContentAdsCount: PropTypes.number.isRequired,
  isFetching: PropTypes.bool.isRequired,
  trovit: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  thirdPartyAdsConfig: PropTypes.object,
  personalizedAds: PropTypes.bool.isRequired,
};

export default List;



// WEBPACK FOOTER //
// ./app/Serp/components/Lists/List/index.js